// extracted by mini-css-extract-plugin
export default {"documentEmpty":"EmptyText_documentEmpty__t3SQ3"};